const PREFIX = "DASHBOARD"
const DASHBOARD_TYPES = {
  COUNT: `${PREFIX}/COUNT`
}

export default DASHBOARD_TYPES
